import { CbhIcon, Text } from "@clipboard-health/ui-components";
import { ButtonBase, Stack } from "@mui/material";
import { PRIORITY_ACCESS_COLOR } from "@src/appV2/lib/Theme/constants";

interface PromoBannerProps {
  message: string;
  actionText: string;
  onAction: () => void;
}

export function PromoBanner({ message, actionText, onAction }: PromoBannerProps) {
  return (
    <Stack
      sx={(theme) => ({
        flexDirection: "row",
        gap: theme.spacing(2),
        paddingY: theme.spacing(2),
        paddingX: theme.spacing(6),
        alignItems: "center",
        justifyContent: "space-between",
        backgroundColor: PRIORITY_ACCESS_COLOR,
        color: theme.palette.common.white,
        boxShadow: theme.shadows[2],
      })}
    >
      <Stack
        sx={{
          flexDirection: "row",
          alignItems: "center",
          flex: 1,
          gap: (theme) => theme.spacing(2),
        }}
      >
        <CbhIcon type="star-filled" size="small" />
        <Text semibold variant="body2" color="currentcolor">
          {message}
        </Text>
      </Stack>
      <ButtonBase onClick={onAction}>
        <Text
          variant="body2"
          color="currentcolor"
          sx={{
            textDecoration: "underline",
            whiteSpace: "nowrap",
            flexShrink: 0,
            fontWeight: 600,
          }}
        >
          {actionText}
        </Text>
      </ButtonBase>
    </Stack>
  );
}
